import { Tooltip } from '@mui/material';
import * as React from 'react';

interface Props {
  label?: string;
  leftCol: string | null | undefined;
  rightCol: string | null | undefined;
  header?: boolean;
  className?: string; // Classname to apply to the entire row
  tooltip?: string;
}

export const Row: React.FC<Props> = (props) => {
  const { label, leftCol, rightCol, header, className, tooltip } = props;

  const changed = !header && (leftCol || rightCol) && leftCol !== rightCol;

  return (
    <div
      className={`border-b px-4 h-14 items-center border-gray-200 grid grid-cols-3 ${className}`}
    >
      <h4>{label}</h4>
      <h4 className="capitalize">{leftCol || '-'}</h4>
      {changed ? (
        <Tooltip title={tooltip || ''}>
          <div className="bg-blue-200 text-blue-900 p-1 w-fit rounded-md">
            <h4 className="capitalize">{rightCol || '-'}</h4>
          </div>
        </Tooltip>
      ) : (
        <h4 className="capitalize">{rightCol || '-'}</h4>
      )}
    </div>
  );
};
Row.displayName = 'Shipments.DetailDrawer.Sections.History.Row';
